
import React from 'react';
import ContentSection from './ContentSection';

const TopPerformingCopiesSection = () => {
  return (
    <ContentSection title="Our Top Performing Copies Responsible For 80% Of Results">
      <div className="flex justify-center">
        <img 
          src="/lovable-uploads/38e06504-cc82-456a-acd6-3ec352158d50.png" 
          alt="Top performing email templates and copy examples" 
          className="rounded-lg shadow-md max-w-full"
        />
      </div>
    </ContentSection>
  );
};

export default TopPerformingCopiesSection;
